import Helpers from '@Apis/helpers';
import dayjs from 'dayjs';
import { toISTDate, QUANTITY } from '@Apis/constants';
import Decimal from 'decimal.js';

class FormHelpers {
  childTaxesData = (data, freightTaxInfo, freightCharge, billFromState, billToState) => {
    // Create a deep copy of the data
    const copyData = JSON.parse(JSON.stringify(data));

    // Add freightTaxInfo if it exists
    if (freightTaxInfo) {
      copyData.push({
        child_taxes: Helpers.computeTaxation(freightCharge, freightTaxInfo, billFromState, billToState)?.tax_info?.child_taxes,
      });
    }

    // Filter out items where `child_taxes` is null, undefined, empty, or contains invalid objects
    const filteredData = copyData?.filter(
      (item) => Array?.isArray(item?.child_taxes)
        && item?.child_taxes?.length > 0
        && item?.child_taxes?.some((tax) => tax?.tax_name && tax?.tax_amount !== 0),
    );

    // Map and flatten the `child_taxes`
    return filteredData?.map((item) => item?.child_taxes)?.flat();
  };

  lineSystemFieldValue = (lineCustomField, systemFields) => {
    return lineCustomField?.map(lineItem => {
      let scfItem = systemFields?.find(scfItem => scfItem.cf_id === lineItem.cfId);
      if (scfItem) {
        return {
          ...lineItem,
          fieldValue: scfItem.field_value
        };
      }
      return {
        ...lineItem, 
        fieldValue: (lineItem.fieldType === 'NUMBERS' ? 0 : lineItem.fieldType === "ATTACHMENT" ? [] : ""),
      };
    });
  }

  // getBatches = (oldBatches, quantity, lineUomInfo, productUomInfo, barcodeBatchId, lineKey) => {
  //   const batches = oldBatches?.map((batch) => ({ ...batch }));
  //   let remainingQty = quantity;
  //   const staticReservations = JSON.parse(sessionStorage.getItem('staticReservations'));
  //   const staticReservationCopy = JSON.parse(JSON.stringify(staticReservations));

  //   const clearLineReservations = () => {
  //     Object.keys(staticReservationCopy)?.forEach((batchKey) => (
  //       delete staticReservationCopy?.[batchKey]?.[lineKey]
  //     ));
  //   };
  //   clearLineReservations();
  //   const getBatchReservations = (batchId) => {
  //     let total = 0;
  //     if (staticReservationCopy?.hasOwnProperty(Number(batchId)) && Object.keys(staticReservationCopy[batchId])?.length > 0) {
  //       Object.keys(staticReservationCopy[batchId])?.forEach((item) => {
  //         total += Number(staticReservationCopy[batchId][item]);
  //       });
  //     }
  //     return {
  //       total,
  //       reservations: staticReservationCopy[batchId],
  //     };
  //   };
  //   const addBatchReservation = (batchId, qty) => {
  //     if (staticReservationCopy?.hasOwnProperty(batchId)) {
  //       if (staticReservationCopy[batchId]?.hasOwnProperty(lineKey)) staticReservationCopy[batchId][lineKey] += qty;
  //       else staticReservationCopy[batchId][lineKey] = qty;
  //     } else {
  //       staticReservationCopy[batchId] = {
  //         [lineKey]: qty,
  //       };
  //     }
  //   };
  //   for (let i = 0; i < batches?.length; i++) {
  //     const batchReservations = getBatchReservations(batches[i]?.batch_id);
  //     batches[i]._reserved = batchReservations;
  //     batches[i].batch_in_use = batchReservations?.batch_in_use || true;
  //     batches[i].consumed_qty = 0;
  //   }
  //   for (let i = 0; i < batches?.length; i++) {
  //     const avlQty = QUANTITY(((Number(batches?.[i]?.available_qty) - Number(batches?.[i]?._reserved?.total)) / lineUomInfo?.ratio) * productUomInfo?.ratio, lineUomInfo?.precision);
  //     if (remainingQty > 0 && Number(batches[i]?.consumed_qty || '0') < avlQty) {

  //       batches[i].consumed_qty = avlQty > remainingQty ? remainingQty : avlQty;
  //       batches[i].batch_in_use = batches[i].batch_in_use;
  //       remainingQty -= batches[i]?.consumed_qty;
  //       addBatchReservation(batches[i]?.batch_id, batches[i]?.consumed_qty);
  //     } else {
  //       batches[i].consumed_qty = 0;
  //       batches[i].batch_in_use = batches[i].batch_in_use;
  //       remainingQty -= batches[i]?.consumed_qty;
  //     }
  //   }

  //   sessionStorage.setItem('staticReservations', JSON.stringify(staticReservationCopy));
  //   return batches?.map((item) => ({ ...item, _reserved: getBatchReservations(item?.batch_id) }));
  // };

  getBatches = (oldBatches, quantity, lineUomInfo, productUomInfo, barcodeBatchId, lineKey) => {
    const batches = oldBatches?.map((batch) => ({ ...batch }));
    let remainingQty = new Decimal(quantity || 0);
  
    const staticReservations = JSON.parse(sessionStorage.getItem('staticReservations'));
    const staticReservationCopy = JSON.parse(JSON.stringify(staticReservations));
  
    const clearLineReservations = () => {
      Object.keys(staticReservationCopy || {})?.forEach((batchKey) => {
        if (staticReservationCopy?.[batchKey]?.[lineKey] !== undefined) {
          delete staticReservationCopy[batchKey][lineKey];
        }
      });
    };
    clearLineReservations();
    const getBatchReservations = (batchId) => {
      let total = new Decimal(0);
      if (
        staticReservationCopy?.hasOwnProperty(batchId) &&
        Object.keys(staticReservationCopy[batchId] || {})?.length > 0
      ) {
        Object.keys(staticReservationCopy[batchId])?.forEach((item) => {
          total = total.plus(new Decimal(staticReservationCopy[batchId][item] || 0));
        });
      }
      return {
        total: total.toNumber(),
        reservations: staticReservationCopy[batchId],
      };
    };
    const addBatchReservation = (batchId, qty) => {
      const decimalQty = new Decimal(qty || 0).toNumber();
      if (staticReservationCopy?.hasOwnProperty(batchId)) {
        if (staticReservationCopy[batchId]?.hasOwnProperty(lineKey)) {
          staticReservationCopy[batchId][lineKey] += decimalQty;
        } else {
          staticReservationCopy[batchId][lineKey] = decimalQty;
        }
      } else {
        staticReservationCopy[batchId] = {
          [lineKey]: decimalQty,
        };
      }
    };
    for (let i = 0; i < batches?.length; i++) {
      const batchReservations = getBatchReservations(batches[i]?.batch_id);
      batches[i]._reserved = batchReservations;
      batches[i].batch_in_use = batchReservations?.batch_in_use || true;
      batches[i].consumed_qty = 0;
    }
    for (let i = 0; i < batches?.length; i++) {
      const availableQty = new Decimal(QUANTITY(batches?.[i]?.available_qty || 0, lineUomInfo?.precision));
      const reservedQty = new Decimal(batches?.[i]?._reserved?.total || 0);
      const lineRatio = new Decimal(lineUomInfo?.ratio || 1);
      const productRatio = new Decimal(productUomInfo?.ratio || 1);
  
      const avlQty = availableQty
        .minus(reservedQty)
        .div(lineRatio)
        .times(productRatio)  
      const currentConsumed = new Decimal(batches[i]?.consumed_qty || 0);
  
      if (remainingQty.gt(0) && currentConsumed.lt(avlQty)) {
        const qtyToConsume = Decimal.min(avlQty, remainingQty);
        batches[i].consumed_qty = qtyToConsume.toNumber();
        batches[i].batch_in_use = batches[i].batch_in_use;
        remainingQty = remainingQty.minus(qtyToConsume);
        addBatchReservation(batches[i]?.batch_id, qtyToConsume);
      } else {
        batches[i].consumed_qty = 0;
        batches[i].batch_in_use = batches[i].batch_in_use;
      }
    }

    sessionStorage.setItem('staticReservations', JSON.stringify(staticReservationCopy));
    return batches?.map((item) => ({
      ...item,
      _reserved: getBatchReservations(item?.batch_id),
    }));
  };

  getBatchesByDepartmentIDs = (tenantDepartmentWiseBatches, tenantIDs) => {
    let result = [];

    tenantIDs?.forEach(id => {
      if (tenantDepartmentWiseBatches?.hasOwnProperty(id)) {
        result = result.concat(tenantDepartmentWiseBatches[id]);
      }
    });

    return result;
  }

  clearLineReservations = (lineKey) => {
    const staticReservations = JSON.parse(sessionStorage.getItem('staticReservations'));
    const staticReservationCopy = JSON.parse(JSON.stringify(staticReservations));
    Object.keys(staticReservationCopy)?.forEach((batchKey) => {
      if (staticReservationCopy?.[batchKey]?.[lineKey] !== undefined) {
        delete staticReservationCopy?.[batchKey]?.[lineKey]
      }
    });
    sessionStorage.setItem('staticReservations', JSON.stringify(staticReservationCopy));
  };

  formatErrorMessage(errorMessage) {
    // Split the error message into lines
    const lines = errorMessage?.split('\n');

    // Map each line to a paragraph element
    const formattedLines = lines?.map(line => `<li>${line.trim()}</li>`);

    // Join the formatted lines into a single HTML string
    return `<ul>${formattedLines?.join('')}</ul>` || formattedLines?.join('');
  }

  /**
 * Converts a quantity from one unit of measurement (UOM) to another.
 *
 * @param {Object} fromUOM - The source UOM object containing the ratio of the unit (productUOMInfo).
 * @param {Object} toUOM - The target UOM object containing the ratio of the unit (lineUOMInfo).
 * @param {number} qty - The quantity to be converted.
 * @param {boolean} [withPrecision=false] - A flag indicating whether to apply precision rounding to the result.
 *
 * @returns {number} - The converted quantity in the target UOM.
 *
 * @description
 * - This function performs a unit conversion based on the ratio of the source and target units.
 * - If `withPrecision` is true, the result is rounded to the precision specified in the target UOM object.
 * - Example use case: Converting quantities between kilograms and grams or liters and milliliters, etc.
 *
 */

  uomConversion = (fromUOM, toUOM, qty, withPrecision = false) => {
    let quantity = (Number(qty) / Number(toUOM?.ratio)) * Number(fromUOM?.ratio);
    if (withPrecision) {
      quantity = QUANTITY(quantity, toUOM?.precision);
    }
    return quantity;
  };

  isValidBatchConsumption = (data, batchLabel, consumedQtyLabel, availableQtyLabel) => {
    for (let i = 0; i < data?.length; i++) {
      if (data[i]?.product_sku_info?.product_type === 'STORABLE') {
        const productBatchInfo = data[i]?.[batchLabel];
        for (let j = 0; j < productBatchInfo?.length; j++) {
          const batchInfo = productBatchInfo[j];
          const consumedQty = batchInfo?.[consumedQtyLabel];
          let availableQty = batchInfo?.[availableQtyLabel];
          availableQty = this.uomConversion(data[i]?.product_sku_info?.uom_info, data[i]?.uom_info, availableQty, true);
          if (consumedQty < 0 || consumedQty > availableQty) {
            return false;
          }
        }
      }
    }
    return true;
  };

  errorChecker = ({ docLevelErrors, lineLevelErrors }) => {
    // Helper to determine if a value is invalid
    const isInvalidValue = (error, value) => {
      if (value === undefined || value === null) return true; // Check for undefined/null
      if (typeof value === 'string' && (value.trim().length === 0 || Number(value) === 0)) return true; // Empty string
      if (typeof value === 'number' && value <= 0) return true; // Non-positive numbers
      if (Array.isArray(value) && value.length === 0) return true; // Empty array
      if (error.name === 'product' && value === 0) return true; // Special case for 'product'
      return false;
    };
  
    // Process errors for each level
    const processErrors = (errors) => errors
      .filter((error) => isInvalidValue(error, error?.value))
      .map((error) => ({
        name: error?.name,
        message: error?.message,
      }));

    // Generate error lists
    const docLevelError = processErrors(docLevelErrors);
    const lineLevelError = processErrors(lineLevelErrors);
  
    return { docLevelError, lineLevelError };
  };

  dateFormatter(date, currentFormat) {
    if (!date || !currentFormat) return null;

    if (currentFormat === 'MM/YYYY' || currentFormat === 'MM/YY') {
      // Return the last millisecond of the last day of the month in ISO format
      return dayjs(date).endOf('month').toISOString();
    } if (currentFormat === 'DD/MM/YYYY') {
      // Return the exact date in ISO format
      return toISTDate(date).toISOString();
    }
    // Fallback for unsupported formats
    return null;
  }

  updatedBatchNumber (data) {

    let newData = [];
    for (let i = 0; i < data?.length; i++) {
      let currData = data?.[i];
    
      // Find the last matching element manually
      let lastElement = null;
      for (let j = newData.length - 1; j >= 0; j--) {
        if (newData[j]?.product_sku_id === currData?.product_sku_id) {
          lastElement = newData[j];
          break;
        }
      }
    
      if (!!lastElement) {
        currData.nextBatchCode = `${currData?.product_sku_info?.internal_sku_code}/${dayjs().format('DDMMYY')}/${Number(lastElement?.nextBatchCode?.split('/')?.[2]) + 1}`;
        currData.selectedBatch.custom_batch_number = `${currData?.product_sku_info?.internal_sku_code}/${dayjs().format('DDMMYY')}/${Number(lastElement?.selectedBatch?.custom_batch_number?.split('/')?.[2]) + 1}`;
        currData.multiple_batch_info[0].custom_batch_number = `${currData?.product_sku_info?.internal_sku_code}/${dayjs().format('DDMMYY')}/${Number(lastElement?.multiple_batch_info?.[0]?.custom_batch_number?.split('/')?.[2]) + 1}`;
      }
    
      newData.push(currData);
    }
    return newData;
  }


  findMatchingRows(dataSource, searchCriteria, excludeKeys = []) {
    // Helper function to filter out excluded keys from an object
    const filterExcludedKeys = (obj) =>
      Object.fromEntries(
        Object.entries(obj).filter(([key]) => !excludeKeys.includes(key))
      );
  
    // Recursive function to check if a key-value pair matches in an object or nested objects
    function doesMatch(obj, key, value) {
      if (!obj || typeof obj !== "object") return false;
  
      if (key in obj) {
        const objValue = obj[key];
        if (Array.isArray(value)) {
          // Handle cases where the search criteria value is an array
          return Array.isArray(objValue)
            ? value.some((v) => objValue.includes(v))
            : value.includes(objValue);
        }
        // Handle cases where the search criteria value is a single value
        return Array.isArray(objValue)
          ? objValue.includes(value)
          : objValue === value;
      }
  
      // Recursively search in nested objects
      return Object.values(obj).some(
        (nestedValue) =>
          typeof nestedValue === "object" && doesMatch(nestedValue, key, value)
      );
    }
  
    // Main logic to filter rows
    return dataSource.filter((row) => {
      const filteredRow = filterExcludedKeys(row);
      return Object.entries(searchCriteria).every(([key, value]) =>
        doesMatch(filteredRow, key, value)
      );
    });
  }
  
}

export default new FormHelpers();
